import React, { useState } from "react";
import "./Signup.css";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import BASE_URL from "../config";

function Signup() {

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {

      Swal.fire({
        icon: "error",
        title: "Passwords do not match",
      });

      return;
    }

    try {

      const res = await fetch(`${BASE_URL}/api/user/signup`, {

        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          password: formData.password,
        }),

      });

      const data = await res.json();

      if (data.success) {

        Swal.fire({
          icon: "success",
          title: "Account Created Successfully",
          timer: 1500,
          showConfirmButton: false,
        });

        navigate("/Userlogin");

      } else {

        Swal.fire({
          icon: "error",
          title: data.message,
        });

      }

    } catch (error) {

      Swal.fire({
        icon: "error",
        title: "Something went wrong",
      });

    }

  };

  return (

    <div className="signup-page">

      <div className="signup-box">

        <h2>Create Account</h2>

        <p>
        Join SAH ? EVERY MOOD HAS A SCENT.
        </p>

        <form onSubmit={handleSubmit}>

          <input
            type="text"
            name="name"
            placeholder="Full Name"
            onChange={handleChange}
            required
          />

          <input
            type="email"
            name="email"
            placeholder="Email Address"
            onChange={handleChange}
            required
          />

          <input
            type="text"
            name="phone"
            placeholder="Phone Number"
            onChange={handleChange}
            required
          />

          <input
            type="password"
            name="password"
            placeholder="Password"
            onChange={handleChange}
            required
          />

          <input
            type="password"
            name="confirmPassword"
            placeholder="Confirm Password"
            onChange={handleChange}
            required
          />

          <button type="submit">
            CREATE ACCOUNT
          </button>

        </form>

        <p className="login-link">

          Already have an account?

          <Link to="/Userlogin">
            Login
          </Link>

        </p>

      </div>

    </div>

  );

}

export default Signup;